import { formatUTCDateTime } from "../../../utils/formatUTCDate";

const dateValidateRegex =  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?\+\d{2}:\d{2}$/;
export const GetFormattedData = (data: any): string => {
  if (data === null || data === undefined || data === "") {
    return "-";
  }

  if (typeof data === 'boolean') {
    return data ? 'True' : 'False';
  }

  if (typeof data === 'number') {
    return data.toString();  // Convert number to string for display
  }

  if (typeof data === 'object') {
    return JSON.stringify(data, null, 2);  // Format with indentation
  }

  if(dateValidateRegex.test(data)) {
    return formatUTCDateTime(data, false, true);
  }

  return data;
};

export const GetFormatTitle = (input: string): string  => {
  return input
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^./, (str) => str.toUpperCase());
}

export const GetSplitAndTrim = (input: string): string[] => {
  return input.split(',')
      .map(item => item.trim())
      .filter(item => item.length > 0);  // Optional: Filters out any empty strings
};